import React from "react";
import Icon from "react-icon-base";

const GlobalBibleLogoIcon = props => (
  <Icon viewBox="0 0 140 130.02" {...props}>
    <g>
      <path d="M70,130a12.13,12.13,0,0,1-8.17-3.16c-7.4-6.71-27.06-22.42-49.48-23.51a8,8,0,0,1-7.61-7.51L0,8.39a8,8,0,0,1,2.26-6A8.08,8.08,0,0,1,8.3,0,99.63,99.63,0,0,1,70,24.34,99.63,99.63,0,0,1,131.7,0a8.1,8.1,0,0,1,6,2.41,8,8,0,0,1,2.26,6l-4.73,87.45a8,8,0,0,1-7.61,7.51c-22.42,1.08-42.07,16.8-49.48,23.51A12.13,12.13,0,0,1,70,130ZM14.63,93.47c23.93,1.84,44,17,53.92,26a2.18,2.18,0,0,0,2.91,0c9.94-9,30-24.14,53.91-26l4.51-83.37A89.28,89.28,0,0,0,79.15,29.65c-.7.57-1.39,1.14-2.05,1.71,8.56,9.58,13.37,19.76,13.23,28.08C90.11,71.91,79.69,76.35,70,76.35S49.89,71.91,49.67,59.44c-.14-8.32,4.67-18.5,13.23-28.08-.66-.57-1.34-1.14-2-1.71A89.25,89.25,0,0,0,10.12,10.1ZM70,38.37c-7.18,8.16-10.41,15.89-10.33,20.9,0,1.94.12,7.08,10.33,7.08s10.3-5.14,10.33-7.08C80.42,54.26,77.18,46.53,70,38.37Z" />
    </g>
  </Icon>
);
export default GlobalBibleLogoIcon;
